export default __webpack_public_path__ + "static/media/last.cb4ba7b0.jpg";